import React, { useContext ,useState} from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link, NavLink, useLocation } from "react-router-dom";
import Container from "@material-ui/core/Container";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import Box from "@material-ui/core/Box";
import LoginButton from "../../Login/loginButton";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import { WebContext } from "../../../../Utility";
import Search from "../../navbarSearch";
import { NAVBAR_EXTERNAL_LINKS } from "../../../../Constants";
import { DesktopMenuDropdown } from "../mobileNavbar";
const useStyles = makeStyles((theme) => ({
  navbar: {
    height: 80,
    width: "100%",
    zIndex: 1,
    background:'transparent !important'
  },
  navLink: {
    color: theme.agentTheme.card.link_foreground,
    whiteSpace: "nowrap",
    "&:before": {
      content: "attr(data-hover)",
      position: "absolute",
      color: theme.palette.primary.main,
      left: "0",
      width: "0",
      transition: "width 0.8s",
      overflow: "hidden",
      whiteSpace: "nowrap",
    },
    "&:hover::before": {
      width: "100%",
    },
    "&$activeNavItem": {
      color: theme.palette.primary.main,
    },
  },
  activeNavItem: {
    color: theme.agentTheme.secondary.main,
  },
  navLinkNonTransparent: {
    color: theme.agentTheme.primary.foreground,
    whiteSpace: "nowrap",
    "&:before": {
      content: "attr(data-hover)",
      position: "absolute",
      color: theme.agentTheme.secondary.main,
      left: "0",
      width: "0",
      transition: "width 0.8s",
      overflow: "hidden",
      whiteSpace: "nowrap",
    },
    "&:hover::before": {
      width: "100%",
    },
    "&$activeNavItem": {
      color: theme.agentTheme.secondary.main,
    },
  },
  navBarContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    height: "inherit",
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
    },
  },
  navBarLogo: {
    margin: "auto 0px",
    "& img": {
      width: "100%",
      objectFit: "contain",
    },
    webkitBackdropFilter: "blur(0px)",
    backdropFilter: "blur(0px)",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "50%",
    },
  },
  navBarContent: {
    display: "flex",
    flexDirection: "row",
  },
  navBarText: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  navBarTextContainer: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    fontSize: "1.5em",
    margin: theme.spacing(0, 1),
  },
  navIcon: {
    margin: "auto 0px",
    color: theme.agentTheme.secondary.main,
    zIndex: 1,
    webkitBackdropFilter: "blur(0px)",
    backdropFilter: "blur(0px)",
  },
  navIconNonTransparent: {
    color: theme.agentTheme.secondary.main,
  },
  navbarTransparentBg: {
    background: "transparent",
  },
  navbarColorNonTransparent: {
    backgroundColor: "transparent",
  },
  searchDiv: {
    margin: "auto 8px",
    width: "25%",
    [theme.breakpoints.down("sm")]: {
      width: "40%",
    },
  },
  loginButton: {
    color: theme.agentTheme.primary.main,
    borderColor: theme.agentTheme.primary.main,
    marginTop: 20,
    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
    },
  },
}));

export default (props) => {
  let {
    logo_url = "",
    contentArr = [],
    username = "",
    getLogoUrl,
    isMobile = false,
    toggleMenu: mobileNavBarOpen = false,
    memberProfile,
    onNavIconClick,
    nonTransparentNav = false,
      handleCovidMenuClose,
    handleCovidMenuItemClick,
    loginItem,
  } = props || {};
  const classes = useStyles();
  const location = useLocation();
  const { isLoggedIn = false } = useContext(WebContext);
  const { website_modules: websiteModules = {} } = memberProfile || {};
  const { packages: isPackagesEnabled = true } = websiteModules || {};
 const [isLoginMenu, setIsLoginMenu] = useState(false);
     const [anchorEl, setAnchorEl] = useState(null);
       const [clickItem, setClickItem] = useState([]);
 const handleCovidMenuClick = (
    event,
    clickItemParam = [],
    islogin = false
  ) => {
    setIsLoginMenu(islogin);
    if (clickItemParam.length > 0) setClickItem(clickItemParam);
    if (anchorEl == null) setAnchorEl(event.currentTarget);
    else handleCovidMenuClose();
  };
  const getNavItem = () => {
    return (
      <>
        {contentArr.map((item) => {
          let showActive = false;
          if (location.pathname == item.link) showActive = true;
          else if (location.pathname == "/" && item.link == `/${username}`)
            showActive = true;
          else if (item.clickHandle) {
            item.clickItem.map((element) => {
              if (
                element.link == location.pathname ||
                element.link.pathname == location.pathname
              )
                showActive = true;
            });
          }

          if (mobileNavBarOpen) {
          } else {
            if (item.clickHandle) {
              return (
                <Box
                  className={classes.navBarTextContainer}
                  position="relative"
                >
                  <div
                    className={`${
                      nonTransparentNav
                        ? classes.navLinkNonTransparent
                        : classes.navLink
                    } ${showActive && classes.activeNavItem} ${
                      classes.navBarText
                    }`}
                    data-hover={item.label}
                    onClick={(e) => handleCovidMenuClick(e, item.clickItem)}
                  >
                    {item.label} {item.dropdown && <KeyboardArrowDown />}
                  </div>
                </Box>
              );
            } else {
              const isExternalLink = NAVBAR_EXTERNAL_LINKS.includes(
                item.label.toLowerCase()
              );
              return (
                <Box
                  className={classes.navBarTextContainer}
                  position="relative"
                >
                  {isExternalLink ? (
                    <a
                      href={item.link}
                      className={`${
                        nonTransparentNav
                          ? classes.navLinkNonTransparent
                          : classes.navLink
                      } ${showActive && classes.activeNavItem}`}
                      data-hover={item.label}
                    >
                      {item.label}
                    </a>
                  ) : (
                    <NavLink
                      to={{
                        pathname: item.link,
                        hash: item.hash || "",
                        state: { memberProfileData: memberProfile },
                      }}
                      className={`${
                        nonTransparentNav
                          ? classes.navLinkNonTransparent
                          : classes.navLink
                      } ${showActive && classes.activeNavItem}`}
                      data-hover={item.label}
                    >
                      {item.label}
                    </NavLink>
                  )}
                </Box>
              );
            }
          }
        })}
      </>
    );
  };

  return (
    <div
      className={`${classes.navbar} ${
        nonTransparentNav
          ? classes.navbarColorNonTransparent
          : classes.navbarTransparentBg
      }`}
    >
      <Container maxWidth={false} className={classes.navBarContainer}>
        <div className={classes.navBarLogo}>
          {!isMobile && logo_url && (
            <Link to={`/${username ? `${username}` : ""}`}>
              <img src={getLogoUrl(logo_url)} height="70" />
            </Link>
          )}
          {isMobile && (
            <div
              className={`${classes.navIcon} ${
                !mobileNavBarOpen &&
                nonTransparentNav &&
                classes.navIconNonTransparent
              }`}
            >
              {!mobileNavBarOpen ? (
                <MenuIcon
                  className={classes.navIcon}
                  onClick={onNavIconClick}
                />
              ) : (
                <CloseIcon
                  className={classes.navIcon}
                  onClick={onNavIconClick}
                />
              )}
            </div>
          )}
        </div>
        {isMobile && logo_url && (
          <Link to={`/${username ? `${username}` : ""}`}>
            <img src={getLogoUrl(logo_url)} height="70" />
          </Link>
        )}
        {!isMobile && (
          <div className={classes.navBarContent}>{getNavItem()}</div>
        )}
        {!isMobile && (
          <Box
            display={"flex"}
            width={"30%"}
            flexDirection={"row"}
            justifyContent={"flex-end"}
          >
            {isPackagesEnabled && (
              <div className={classes.searchDiv} style={{ width: "100%" }}>
                <Search type="NAVBAR_SEARCH_3" />
              </div>
            )}
            <Box
              width={"50%"}
              onClick={(e) => isLoggedIn && handleCovidMenuClick(e, [], true)}
            >
              <LoginButton loginClass={classes.loginButton} />
            </Box>
          </Box>
        )}
        {isMobile && <LoginButton loginClass={classes.loginButton} />}
      </Container>
       {(isLoginMenu || clickItem.length > 0) && (
                          <DesktopMenuDropdown
                            anchorEl={anchorEl}
                            handleCovidMenuClose={handleCovidMenuClose}
                            loginMenu={isLoginMenu}
                            clickItem={isLoginMenu ? loginItem : clickItem}
                            handleCovidMenuItemClick={handleCovidMenuItemClick}
                          />
                        )}
    </div>
  );
};
